/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} Gateway_UnavailableInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Gateway unavailable" |
* | "true" | "Gateway unavailable since {date}" |
* | * | "Gateway unavailable" |
*
* @param {Gateway_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_unavailable = /** @type {((inputs: Gateway_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Gateway unavailable`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Gateway unavailable since ${i?.date}`);
		return /** @type {LocalizedString} */ (`Gateway unavailable`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Box non disponible`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Box non disponible depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`Box non disponible`)
	}
});